<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card>
      <v-card-title class="text-h5">{{ formTitle }}</v-card-title>
      <v-row v-if="progressShow">
        <v-col class="d-flex justify-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#6a6aec" text @click="closeDelete">ביטול</v-btn>
        <v-btn color="#6a6aec" text @click="actionConfirmed">אישור</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'

export default {
  props: {
    itemIndex: Number,
    item: Object,
    formTitle: String,
    value: { type: Boolean, default: false },

  },
  data: () => ({
    progressShow: false,
  }),

  methods: {
    actionConfirmed() {
      this.deleteUser();
    },

    async deleteUser() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const datesJSON = JSON.stringify(this.item);

        let api = process.env.VUE_APP_BASE_URL + "/admin/delete_user";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", datesJSON, token));
        this.progressShow = false;
        if (res.status === 400) {
          this.$emit("userDeleted", "", "תקלה במחיקת רשומה", "red");
        } else if (res.status === 403) {
          const jsonObject = await res.json();
          this.$emit("userDeleted", "", " :שגיאה במחיקת משתמש" + jsonObject.message, "red");
          this.openMode = false;
        } else if (res.status === 200) {
          this.$emit("userDeleted", this.itemIndex, "הרשומה נמחקה בהצלחה!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.progressShow = false;
        this.$emit("userDeleted", "", "תקלה במחיקת רשומה", "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    }
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
}
</script>

  